// Socket debugging utility
// Usage: In browser console, run: window.enableSocketDebug()

import { logger } from "./logger";

export const enableSocketDebug = () => {
  if (typeof window !== 'undefined') {
    (window as any).socketDebugEnabled = true;
    logger.log('✅ Socket debugging enabled');
    logger.log('📝 Open the debug panel by running: window.showSocketDebug()');
  }
};

export const disableSocketDebug = () => {
  if (typeof window !== 'undefined') {
    (window as any).socketDebugEnabled = false;
    logger.log('❌ Socket debugging disabled');
  }
};

export const showSocketDebug = () => {
  if (typeof window !== 'undefined') {
    (window as any).socketDebugPanelOpen = true;
    logger.log('✅ Socket debug panel will appear on next render');
  }
};

export const hideSocketDebug = () => {
  if (typeof window !== 'undefined') {
    (window as any).socketDebugPanelOpen = false;
    logger.log('❌ Socket debug panel hidden');
  }
};

// Auto-expose to window for easy access
if (typeof window !== 'undefined') {
  (window as any).enableSocketDebug = enableSocketDebug;
  (window as any).disableSocketDebug = disableSocketDebug;
  (window as any).showSocketDebug = showSocketDebug;
  (window as any).hideSocketDebug = hideSocketDebug;
  
  logger.log('🔍 Socket debugger loaded. Available commands:');
  logger.log('   window.enableSocketDebug()  - Enable socket debugging');
  logger.log('   window.showSocketDebug()    - Show debug panel');
  logger.log('   window.hideSocketDebug()    - Hide debug panel');
}
